import React, {Fragment, useState, useEffect} from 'react'
import {Button, Col, Row} from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import UserService from '../../../../../services/user'
import {toast} from 'react-toastify'
import FormGenerator from '../../../../../utils/helpers/FormGenerator'
import MasterServices from '../../../../../services/master'
import useDebounce from '../../../../../utils/hooks/useDebounce'

type Props = {
  onChange?: (e: any) => void
  toggle: () => void
  getData: any
  editFormValue?: any
  master?: any
}

const Forms: React.FC<Props> = ({toggle, getData, editFormValue, master}) => {
  const [loading, setLoading] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [formValue, setFormValue] = useState<any>({
    title: '',
    company_name: '',
    start_date: '',
    end_date: '',
    industries: '',
    description: '',
  })
  const [file, setFile] = useState<any>(null)

  const [inputs, setInputs] = useState<any>([
    {
      name: 'languages',
      label: 'Bahasa Yang Anda Kuasai*',
      type: 'select-creatable',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'languages_name',
      getItemValueId: 'languages_id',
    },
    {
      name: 'speaking',
      label: 'Kemampuan Percakapan*',
      type: 'select2',
      validation: {},
      col: 4,
      options: master,
      additional: '',
      getItemValue: 'proficiencies_name',
      getItemValueId: 'proficiencies_id',
    },
    {
      name: 'reading',
      label: 'Kemampuan Membaca*',
      type: 'select2',
      validation: {},
      col: 4,
      options: master,
      additional: '',
      getItemValue: 'proficiencies_name',
      getItemValueId: 'proficiencies_id',
    },
    {
      name: 'writing',
      label: 'Kemampuan Menulis*',
      type: 'select2',
      validation: {},
      col: 4,
      options: master,
      getItemValue: 'proficiencies_name',
      getItemValueId: 'proficiencies_id',
    },
    {
      name: 'is_certificate',
      label: 'Terdapat Sertifikat?',
      type: 'select2',
      validation: {},
      col: 6,
      options: [
        {
          name: 'Ya',
          value: 1,
        },
        {
          name: 'Tidak',
          value: 0,
        },
      ],
      getItemValue: 'name',
      getItemValueId: 'value',
    },
    {
      name: 'institution',
      label: 'Nama Institusi Penerbit Sertifikat (Opsional)',
      type: 'text',
      validation: {},
      col: 6,
      disabled: false,
      options: [],
      additional: '',
    },
    {
      name: 'description',
      label: 'Deskripsi (Opsional)',
      type: 'textarea',
      validation: {},
      col: 12,
      options: [],
      additional: '',
    },
  ])

  useEffect(() => {
    let clone = inputs
    for (let i = 1; i <= 3; i++) {
      clone[i].items = master
      clone[i].options = master
    }
    setInputs(clone)
  }, [master])

  useEffect(() => {
    setFormValue(editFormValue)
    setDisabled(true)
    disableUpload(editFormValue?.is_certificate)
  }, [editFormValue])

  const disableUpload = (value: number) => {
    let cloneForms = inputs
    cloneForms[5].disabled = value == 1 ? false : true
    setInputs(cloneForms)
    setDisabled(value == 1 ? false : true)
  }

  const onChange = (e: any) => {
    const {name, value} = e.target

    if (name === 'upload') {
      setFile(e.target.files[0])
      return
    }

    if (name === 'is_certificate') {
      disableUpload(value.value)
    }

    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  useDebounce(
    () => {
      getLanguage('')
    },
    250,
    []
  )

  const getLanguage = async (q: any) => {
    try {
      setLoading(true)
      const {data} = await MasterServices.getLanguage({...{is_active: 1}, q})
      let clone = inputs
      clone[0].items = data.data
      clone[0].options = data.data
      setInputs(clone)
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  const onSelect = (input: any, row: any, key: any) => {
    const name = input
    switch (name) {
      case 'languages':
        getLanguage(row)
        break
    }
  }

  const uploadFile = async (id?: any) => {
    setLoading(true)
    await UserService.uploadFileLanguage({file}, id)
      .then(() => {
        toast.success(`Bahasa Berhasil ${id ? 'Diperbarui' : 'Dibuat'}`)
        toggle()
        getData()
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
      })
  }

  const handleSubmit = async (e: any) => {
    e?.preventDefault()
    const formData = new FormData(e.target)
    const formProps = Object.fromEntries(formData)

    setLoading(true)
    await UserService.createOrUpdateLanguage(formProps, editFormValue?.rowDetail?.user_languages_id)
      .then((response) => {
        let id = editFormValue?.rowDetail?.user_languages_id ?? response.data?.user_languages_id
        if (file) {
          uploadFile(id)
          return
        }

        toast.success(`Bahasa Berhasil ${id ? 'Diperbarui' : 'Dibuat'}`)
        toggle()
        getData()
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
      })
  }

  return (
    <Fragment>
      <Form onSubmit={handleSubmit}>
        <Row>
          {master && FormGenerator(inputs, formValue, onChange, onSelect, loading)}
          <Col md={12}>
            <Row className='d-grid gap-4'>
              <Col md={12}>
                <Form.Label>Unggah Dokumen Pendukung (Opsional)</Form.Label>
              </Col>
              <Col md={12}>
                <input type='file' name='upload' disabled={disabled} onChange={onChange} />
              </Col>
              {formValue?.rowDetail?.document_url_full &&
              formValue?.rowDetail?.user_languages_certificate == 1 ? (
                <Col md={12}>
                  <a href={formValue?.rowDetail?.document_url_full} target='_blank'>
                    Dokumen Pendukung
                  </a>
                </Col>
              ) : null}
              <Col md={12}>
                <Form.Text>pdf Max file size is 2MB</Form.Text>
              </Col>
            </Row>
          </Col>
        </Row>
        <Modal.Footer>
          <Button className='btn btn-secondary btn-sm' onClick={toggle} disabled={loading}>
            Batalkan
          </Button>
          <Button className='btn btn-primary btn-sm' type='submit' disabled={loading}>
            {loading ? 'Loading' : 'Simpan'}
          </Button>
        </Modal.Footer>
      </Form>
    </Fragment>
  )
}

export default Forms
